import { defineStore } from 'pinia'

import { createReportExecutionActions } from './actions'
import { createReportExecutionState } from './state'

export const useReportExecutionStore = defineStore('reportExecution', () => {
    const state = createReportExecutionState()
    const actions = createReportExecutionActions(state)

    return {
        ...state,
        ...actions
    }
})
